import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { UseCase } from '@domain/base/use-case';
import { UpdateUserBatchModel, UpdateUserBatchResult } from '@domain/models/update-user-batch.model';
import { UserRepository } from '@domain/repositories/user.repository';


@Injectable({
  providedIn: 'root',
})
export class UpdateUserBatchUseCase implements UseCase<UpdateUserBatchModel[], UpdateUserBatchResult[]> {
  constructor(private userRepository: UserRepository ) { }
  execute(updateBatchData: UpdateUserBatchModel[]): Observable<UpdateUserBatchResult[]> {
    return this.userRepository.updateUserBatch(updateBatchData); 
  }
}
